import { SeoLinks } from '../../components/SeoLinks';
import { useSelector } from 'react-redux';
import * as React from 'react';
import { seoLinksSelector } from '../../selectors';

export const SeoLinksContainer = () => {
  const links = useSelector(seoLinksSelector);

  return <SeoLinks links={links} />;
};
